import PropTypes from 'prop-types';
import React from 'react';

const MerchantBadge = () => (
  <svg viewBox="0 0 24 24">
    <defs>
      <linearGradient id="prefix__a" x1="15.542%" x2="84.46%" y1="11.73%" y2="88.271%">
        <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
        <stop offset="100%" stopColor="#FFF" stopOpacity=".196" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect width="24" height="24" fill="#02A78B" rx="12" />
      <rect width="22" height="22" x="1" y="1" fill="url(#prefix__a)" rx="11" />
      <path
        fill="#FFF"
        d="M18.169 12.416c.277 0 .5.223.5.5v4.998c0 .276-.223.5-.5.5H5.824c-.276 0-.5-.224-.5-.5v-4.998c0-.277.224-.5.5-.5.277 0 .5.223.5.5v2.522h11.345v-2.522c0-.277.224-.5.5-.5zm-.5 4.022H6.324v.976h11.345v-.976zm.581-10.852c.229 0 .428.156.485.377l1.028 4.058c.01.04.015.082.015.123 0 1.253-1.04 2.272-2.319 2.272-.743 0-1.399-.35-1.824-.884-.425.537-1.076.884-1.815.884-.741 0-1.395-.348-1.82-.88-.425.532-1.079.88-1.82.88-.739 0-1.391-.347-1.816-.876-.424.526-1.079.876-1.823.876-1.279 0-2.319-1.02-2.319-2.272 0-.041.005-.082.015-.123l1.029-4.058c.056-.221.255-.377.485-.377zm-.389 1H15.84l.297 3.516.002.042c0 .7.592 1.272 1.32 1.272.708 0 1.287-.54 1.318-1.215l-.916-3.615zm-3.024 0H12.5v3.558c0 .7.592 1.272 1.32 1.272.725 0 1.314-.567 1.318-1.266l-.288-3.416-.013-.148zm-3.337 0H9.163l-.304 3.6c.002.659.594 1.23 1.321 1.23.728 0 1.32-.571 1.32-1.272V6.586zm-3.34 0H6.14L5.223 10.2c.031.675.611 1.215 1.318 1.215.728 0 1.32-.571 1.32-1.272l.299-3.558z"
      />
    </g>
  </svg>
);

MerchantBadge.propTypes = {
  className: PropTypes.string,
};

export default MerchantBadge;
